
import EndPoints from "src/Constants/EndPoints";
import useApiFetchInfinite from "src/Hooks/Shared/useApiFetchInfinite";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import NotificationItem from "../NotificationItem/NotificationItem";
import { useTranslation } from "react-i18next";

function NotificationsList() {
  const { user } = AppStateHandler.getState();
  const { t, i18n } = useTranslation();
  const endPoint = EndPoints.notifications;
  const { data, refetch } = useApiFetchInfinite(
    [
      `${endPoint}?subId=${user?.username}`,
    ],
    {
      getFetchMore: (lastData) => {
        const nextPage = lastData?.data?.Page;
        const totalPages = lastData?.data?.TotalPages;

        return parseInt(nextPage ?? "1", 10) < totalPages
          ? `&page=${parseInt(nextPage ?? "1", 10) + 1}`
          : null;
      },
    }
  );

  const arrayData = (Array.isArray(data) ? data : [])
    .map((_) => _.data.Items)
    .reduce((a, b) => a.concat(b), []);
    // console.log(arrayData);
  return (
    <div className={`user_actions ${i18n.dir()==='rtl'?'user_actions_posRTL text-right':'user_actions_posLTR'} notification_action py-3 px-1`}>
      <div className="d-flex justify-content-between align-items-center mb-4 px-2 ">
        <h2 className="fz20 mb-0 font-weight-normal">{t("Notifications")}</h2>
      </div>
      {
        
        arrayData.length === 0 ? <p className="px-2">{t("No notifications available")}</p> :
          arrayData.map((_n: any, _i: number) => {
            return <NotificationItem key={_i} data={_n} refetch={refetch} />
          })
      }
    </div>
  )
}

export default NotificationsList;